import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './Components/LandingPage';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Containerlan from './Components/Containerlan';
// import EnterprisePage from './Components/Enterprise';
// import Requter from './Components/Requter';
import Slideslan from './Components/Slideslan';
import FAQSection from './Components/FAQ';
// import CollegeHiring from './Components/Collages';
import AIResumePage from './Components/AIResume';
import AiMockInterview from './Components/AIMock';
import MentorshipModule from './Components/Mentoship';
import SkillLogin from './Components/SkillLogin';
import JobSourcing from './Components/JobSemless';
import SkillsHapUniversityHero from './Components/SkillsHapUniversityHero';
import InstituteModule from './Components/InstituteModule';
import RecruiterPage from './Components/RecruiterPage';
import CareerCoachModule from './Components/CareerCoachModule';
import HrPage from './Components/HrPage';
import Sales from './Components/Sales';
import Coach from './Components/Coach';
import SignupForm from './Components/SignupForm';
import BookDemoForm from './Components/BookDemoForm';
import RegisterForm from './Components/RegisterForm';
import RegisterNow from './Components/RegisterNow';
import TermsAndConditions from './Components/TermsAndConditions';
import ContactSkill from './Components/ContactSkill';
import PrivacyPolicy from './Components/PrivacyPolicy';
import AboutUs from './Components/About';
import MockInterviewers from './Components/MockInterviewers';
import LearningCollaborators from './Components/LearningCollaborators';
import RedirectToForm from './Components/RedirectToForm';


function App() {
  return (
    <Router>
      <Navbar />
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
              <Route path="/containerlan" element={<Containerlan />} />
              <Route path="/institutes" element={<InstituteModule />} />
              <Route path="/Careerpage" element={<CareerCoachModule/>} />
              <Route path="/RecruiterPage" element={<RecruiterPage/>} />
                <Route path="/slideslan" element={<Slideslan/>} />
                 <Route path="/faq" element={<FAQSection/>} />
          <Route path="/colleges" element={<SkillsHapUniversityHero/>} /> 
          <Route path="/airesume" element={<AIResumePage/>} />
        <Route path="/aimock" element={<AiMockInterview/>} />
         <Route path="/mentorship" element={<MentorshipModule/>} />
          <Route path="/Login" element={<SkillLogin/>} />
          <Route path="/jobsemless" element={<JobSourcing/>} />
          <Route path="/HrPage" element={<HrPage/>} />
          <Route path="/Sales" element={<Sales/>} />
          <Route path="/Coach" element={<Coach/>} />
          <Route path="/MockInterviewers" element={<MockInterviewers/>} />
          <Route path="/LearningCollaborators" element={<LearningCollaborators/>} />
          <Route path="/SignupForm" element={<SignupForm/>} />
          <Route path="/BookDemoForm" element={<BookDemoForm/>} />
          <Route path="/RegisterForm" element={<RegisterForm/>} />
          <Route path="/RegisterNow" element={<RegisterNow/>} />
          <Route path="/TermsAndConditions" element={<TermsAndConditions/>} />
          <Route path="/ContactSkill" element={<ContactSkill/>} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy/>} />
          <Route path="/AboutUs" element={<AboutUs/>} />
          <Route path="/RedirectToForm" element={<RedirectToForm/>} />
        </Routes>
      </div>
      <Footer/>
    </Router>
  );
}

export default App;
